import { computed } from 'vue';
import { useSettingsStore } from '@/stores/settings';

/**
 * Currency composable for consistent currency formatting across the project
 * LKR → Rs.
 * USD → $
 * EUR → €
 * GBP → £
 */
export function useCurrency() {
  const settingsStore = useSettingsStore();
  
  // Fetch settings on mount if not already loaded
  if (!settingsStore.settings || Object.keys(settingsStore.settings).length === 0) {
    settingsStore.fetchSettings();
  }
  
  // Currency symbol mapping
  const getCurrencySymbol = () => {
    const currency = settingsStore.getCurrency || 'LKR';
    const currencyMap = {
      'LKR': 'Rs.',
      'USD': '$',
      'EUR': '€',
      'GBP': '£'
    };
    return currencyMap[currency] || currency;
  };
  
  // Computed property for currency symbol
  const currencySymbol = computed(() => getCurrencySymbol());
  
  // Format price function
  const formatPrice = (price) => {
    if (price === null || price === undefined || price === '') {
      return '0.00';
    }
    const priceNum = parseFloat(price);
    if (isNaN(priceNum)) {
      return '0.00';
    }
    return priceNum.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };
  
  // Format price with currency symbol
  const formatPriceWithCurrency = (price) => {
    return `${currencySymbol.value} ${formatPrice(price)}`;
  };
  
  return {
    currencySymbol,
    formatPrice,
    formatPriceWithCurrency
  };
}